export const WIDGET_REGISTRY = {
  welcome_hero: {
    id: "welcome_hero",
    title: "Welcome Hero Banner",
    category: "Overview",
    description: "Event title, quick website link, and event settings shortcut",
    defaultColSpan: 4,
    minColSpan: 3,
    maxColSpan: 12,
    allowHide: true,
    configurable: true,
  },
  exhibitors: {
    id: "exhibitors",
    title: "Exhibitors Count",
    category: "Attendees",
    description: "Total count of registered exhibitors with trend breakdown",
    defaultColSpan: 2,
    minColSpan: 2,
    maxColSpan: 6,
    allowHide: true,
    configurable: true,
  },
  visitors: {
    id: "visitors",
    title: "Visitors Count",
    category: "Attendees",
    description: "Total visitor registrations count with trend breakdown",
    defaultColSpan: 2,
    minColSpan: 2,
    maxColSpan: 6,
    allowHide: true,
    configurable: true,
  },
  special_invitees: {
    id: "special_invitees",
    title: "Special Invitees Count",
    category: "Attendees",
    description: "Special invitee registrations count with quick link",
    defaultColSpan: 2,
    minColSpan: 2,
    maxColSpan: 6,
    allowHide: true,
    configurable: true,
  },
  students: {
    id: "students",
    title: "Student Visitors Count",
    category: "Attendees",
    description: "Student registration count with quick link",
    defaultColSpan: 2,
    minColSpan: 2,
    maxColSpan: 6,
    allowHide: true,
    configurable: true,
  },
  app_social_wall: {
    id: "app_social_wall",
    title: "Social Wall App Card",
    category: "Apps & Modules",
    description: "Quick module card for event social feed and wall",
    defaultColSpan: 2,
    minColSpan: 2,
    maxColSpan: 6,
    allowHide: true,
    configurable: true,
  },
  app_ufi_analytics: {
    id: "app_ufi_analytics",
    title: "UFI Analytics App Card",
    category: "Apps & Modules",
    description: "Quick module card for UFI benchmarking analytics",
    defaultColSpan: 2,
    minColSpan: 2,
    maxColSpan: 6,
    allowHide: true,
    configurable: true,
  },
  app_event_catalogue: {
    id: "app_event_catalogue",
    title: "Catalogue App Card",
    category: "Apps & Modules",
    description: "Quick module card for event product & exhibitor catalogue",
    defaultColSpan: 2,
    minColSpan: 2,
    maxColSpan: 6,
    allowHide: true,
    configurable: true,
  },
  app_onsite_module: {
    id: "app_onsite_module",
    title: "Onsite Module App Card",
    category: "Apps & Modules",
    description: "Quick module card for onsite activities & passes",
    defaultColSpan: 2,
    minColSpan: 2,
    maxColSpan: 6,
    allowHide: true,
    configurable: true,
  },
  app_oes_analytics: {
    id: "app_oes_analytics",
    title: "OES Analytics App Card",
    category: "Apps & Modules",
    description: "Quick module card for OES form submissions and analytics",
    defaultColSpan: 2,
    minColSpan: 2,
    maxColSpan: 6,
    allowHide: true,
    configurable: true,
  },
  app_database: {
    id: "app_database",
    title: "Database App Card",
    category: "Apps & Modules",
    description: "Quick module card for event database management and export",
    defaultColSpan: 2,
    minColSpan: 2,
    maxColSpan: 6,
    allowHide: true,
    configurable: true,
  },
  trade_delegates: {
    id: "trade_delegates",
    title: "Trade Delegates Action Box",
    category: "Attendees",
    description: "Total approved & pending trade delegates with approval workflow button",
    defaultColSpan: 4,
    minColSpan: 3,
    maxColSpan: 12,
    allowHide: true,
    configurable: true,
  },
  product_uploads: {
    id: "product_uploads",
    title: "Product Uploads Metric",
    category: "Operational",
    description: "Total uploaded product catalog items and trend sparkline",
    defaultColSpan: 2,
    minColSpan: 2,
    maxColSpan: 6,
    allowHide: true,
    configurable: true,
  },
  countries_count: {
    id: "countries_count",
    title: "Countries Count Metric",
    category: "Operational",
    description: "Number of unique participating countries",
    defaultColSpan: 2,
    minColSpan: 2,
    maxColSpan: 6,
    allowHide: true,
    configurable: true,
  },
  oes_submits: {
    id: "oes_submits",
    title: "OES Submissions Metric",
    category: "Operational",
    description: "Total submitted Online Exhibitor Services forms",
    defaultColSpan: 2,
    minColSpan: 2,
    maxColSpan: 6,
    allowHide: true,
    configurable: true,
  },
  team_members: {
    id: "team_members",
    title: "Team Members Metric",
    category: "Operational",
    description: "Total staff badge / team members count",
    defaultColSpan: 2,
    minColSpan: 2,
    maxColSpan: 6,
    allowHide: true,
    configurable: true,
  },
  monthwise_chart: {
    id: "monthwise_chart",
    title: "Registrations by Month Chart",
    category: "Analytics",
    description: "Area line chart showing registration volume over time",
    defaultColSpan: 6,
    minColSpan: 4,
    maxColSpan: 12,
    allowHide: true,
    configurable: true,
  },
  countrywise_chart: {
    id: "countrywise_chart",
    title: "Registrations by Country Chart",
    category: "Analytics",
    description: "Horizontal bar chart with country flags and counts",
    defaultColSpan: 6,
    minColSpan: 4,
    maxColSpan: 12,
    allowHide: true,
    configurable: true,
  },
  industry_sector_chart: {
    id: "industry_sector_chart",
    title: "Registrations by Industry Sector Chart",
    category: "Analytics",
    description: "Bar chart showing attendee distribution across industry sectors",
    defaultColSpan: 6,
    minColSpan: 4,
    maxColSpan: 12,
    allowHide: true,
    configurable: true,
  },
  event_discovery_chart: {
    id: "event_discovery_chart",
    title: "Registrations by Event Discovery Chart",
    category: "Analytics",
    description: "Bar chart showing media channel attribution and event discovery metrics",
    defaultColSpan: 6,
    minColSpan: 4,
    maxColSpan: 12,
    allowHide: true,
    configurable: true,
  },
  statewise_chart: {
    id: "statewise_chart",
    title: "Registrations by State Chart",
    category: "Analytics",
    description: "Bar chart showing attendee distribution by Indian state",
    defaultColSpan: 6,
    minColSpan: 4,
    maxColSpan: 12,
    allowHide: true,
    configurable: true,
  },
  designation_chart: {
    id: "designation_chart",
    title: "Registrations by Designation Chart",
    category: "Analytics",
    description: "Bar chart showing attendee breakdown by job title / designation",
    defaultColSpan: 6,
    minColSpan: 4,
    maxColSpan: 12,
    allowHide: true,
    configurable: true,
  },
};
